module.exports = __webpack_public_path__ + "media/images/icons/meat-853733fed119e5e8b0d1fd88a155b685.png";